<template>
 <v-card class="pb-1" min-width="300" light>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/')"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Régions
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card>
      <v-card-title>
        Régions
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="_.sortBy(Regions, ['ll_region'])" :search="search">
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="gotToItem(item)">
            mdi-chevron-right
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
 </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Région",
          value: "ll_region",
        },
        { text: "Province", value: "ll_province" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  mounted() {
    this.GetRegions();
    this.GetProvinces();
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      Regions: (state) => state.Regions.Regions,
      Provinces: (state) => state.Provinces.Provinces,
    }),
  },
  methods: {
    ...mapActions({
      GetRegions: "Regions/GetAll",
      GetProvinces: "Provinces/GetAll",
    }),
    editItem(item) {
      console.log(item);
    },

    deleteItem(item) {
      this.$confirm("Voulez vous vraiment supprimer cette région").then(
        (res) => {
          if (res) {
            console.log(item);
          }
        }
      );
    },

    gotToItem(item) {
    this.$router.push("/geographie/region/"+item.id)
    },
  },
};
</script>

<style scoped></style>
